import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { Kpi } from '@app/_models';

const httpOptions = {
  headers: new HttpHeaders({
    key: 'rejc41r2421sk8423jd39',
  }),
};

@Injectable({ providedIn: 'root' })
export class EditService {
  constructor(private http: HttpClient) {}

  editKPI(kpi: Kpi) {
    return this.http.put<Kpi[]>(
      `${environment.api_backend.url}/kpi/` + kpi.id,
      kpi,
      httpOptions
    );
  }

  editTextSlide(textSlide: Kpi) {
    return this.http.put<Kpi[]>(
      `${environment.api_backend.url}/text_slide/` + textSlide.id,
      textSlide,
      httpOptions
    );
  }
}
